import { getApiUrl } from '../utils/apiUrl';

const API_URL = getApiUrl();

export const buildHeaders = (token) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

export const handleResponse = async (response, fallbackMessage = 'Request failed.') => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const message = errorData.error || errorData.message || fallbackMessage;
    const error = new Error(message);
    error.status = response.status;
    if (errorData.code) error.code = errorData.code;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    return response.json();
  }

  return response.text();
};

export { API_URL };
